import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    event.preventDefault()
    const locale = event.currentTarget.dataset.locale
    this.tabTargets.forEach((t) => {
      t.classList.toggle("tab-active", t.dataset.locale === locale)
    })
    this.panelTargets.forEach((p) => {
      p.classList.toggle("hidden", p.dataset.locale !== locale)
    })
  }
}
